import Song from "./SongQueue/Song";
import {IconButton, List, makeStyles, Typography} from "@material-ui/core";
import React, {useState} from "react";
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PauseIcon from '@material-ui/icons/Pause';
import SkipNextIcon from '@material-ui/icons/SkipNext';
import {playNextSong} from "../../controllers/spotifyController";
import {getState} from "../../controllers/stateController";


const useStyles = makeStyles((theme) => ({
    iconButton: {
        color: "white",
    },
    iconButtonDisabled: {
        color: "grey !important"
    },
    list: {
        backgroundColor: theme.palette.secondary.light
    },
}))


function NowPlayingActionButton({song}) {
    const classes = useStyles();
    const [disabled, setDisabled] = useState(false)

    const handleSkip = () => {
        global.player.getCurrentState().then(state => {
            if (state) {
                setDisabled(true);
                setTimeout(() => {
                    setDisabled(false);
                }, 500);
                const nextSong = getState().next_song
                playNextSong(nextSong["uri"], nextSong["offset"])
            }
        });
    };

    const handlePlayPause = () => {
        global.player.getCurrentState().then(state => {
            if (state) {
                if(song.is_playing) {
                    global.player.pause().then(value => {}, reason => {
                        // rejection
                        console.log(reason)
                    });
                }
                else {
                    global.player.resume().then(value => {}, reason => {
                        // rejection
                        console.log(reason)
                    });
                }
            }
        });
    };


    return(
       <div>
           <IconButton
               aria-label="playpause"
               onClick={handlePlayPause}
               color="primary"
               classes={{
                   colorPrimary: classes.iconButton
               }}
           >
               {song.is_playing ? <PauseIcon /> : <PlayArrowIcon />}
           </IconButton>
           <IconButton
               aria-label="skip"
               onClick={() => handleSkip()}
               color="primary"
               classes={{
                   colorPrimary: classes.iconButton,
                   disabled: classes.iconButtonDisabled
               }}
               disabled={disabled}
           >
               <SkipNextIcon />
           </IconButton>
       </div>
    )
}


function NowPlaying( {now_playing, getNextSong} ) {
    return(
        <React.Fragment>
            {now_playing === undefined || Object.keys(now_playing).length === 0
                ? <h1>No song playing.</h1>
                :
                <React.Fragment>
                    <Typography variant="body1" color="initial">
                        <b>Now Playing</b>
                    </Typography>
                    <List>
                        <Song track={now_playing} action={getState().role === "host"
                            ? <NowPlayingActionButton song={now_playing} getNextSong={() => getNextSong()}/>
                            : null
                        }
                        />
                    </List>
                </React.Fragment>
            }
        </React.Fragment>
    )
}

export default NowPlaying
